
/**
 * Module dependencies.
 */

var Facade = require('@segment/to-facade');

/**
 * Expose `summarize`.
 */

module.exports = summarize;

/**
 * Summarize `request`.
 *
 * @param {Object} request
 * @return {String}
 * @api public
 */

function summarize(request){
  var f = Facade(request);

  switch (f.type()) {
    case 'alias': return f.userId();
    case 'identify':
      var id = f.userId();
      if (!id) return 'Anonymous ID: ' + f.anonymousId();
      var extra = f.email() || f.username() || f.name();
      if (extra) id += ' (' + extra + ')';
      return id;
    case 'group': return f.groupId();
    case 'page': return f.fullName() || f.properties().path;
    case 'track': return f.event();
    case 'screen': return f.fullName();
    default: return 'Unknown Request';
  }
}



//////////////////
// WEBPACK FOOTER
// ../~/@segment/summarize-request/index.js
// module id = 1173
// module chunks = 0